import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import {
  GetBasketsByParty,
  // NoBasketSelectedDTO,
  NoNameGivenDTO,
  PartyBasketDTO,
  PartyBasketResponse,
  StartViewBasketForSalesCenterUser,
  TrivialDeliveryPolicyDTO,
  UserInfoDTO
} from '@cloudsuite/cs-ordering-defs'
import { executeOrderingRequest } from 'components/ordering/executor.js'

export const OPEN_BASKET_OVERVIEW_API = Symbol('OPEN_BASKET_OVERVIEW_API')

export interface OpenBasketOverviewAPI {
    viewBasket(basketId: string): Promise<void>;
    getOpenBasketsForParty(request: GetBasketsByParty): Promise<PartyBasketResponse>;
}


@registerDependency(FAKE, OPEN_BASKET_OVERVIEW_API)
export class FakeOpenBasketOverviewAPI implements OpenBasketOverviewAPI {
    public static readonly EXPECTED_PARTY = 5
    public static readonly EXPECTED_SHOP = 1
    public static viewedBasket: string | null = null
    public static readonly HARDCODED_PARTY_BASKETS: () => PartyBasketDTO[] = () => ([
      new PartyBasketDTO(
        'basket-1',
        'Summer BBQ Supplies',
        new UserInfoDTO(
          1,
          'John',
          'Q',
          'Public',
          'john.public@example.com',
        ),
        new TrivialDeliveryPolicyDTO(),
        5,
        5,
        new Date('2023-06-13T10:30:00Z'),
      ),
      new PartyBasketDTO(
        'basket-2',
        new NoNameGivenDTO(),
        new UserInfoDTO(
          2,
          'Jane',
          '',
          'Doe',
          'jane.doe@example.com',
        ),
        new TrivialDeliveryPolicyDTO(),
        3,
        3,
        new Date('2025-06-20T14:15:00Z'),
      ),
    ])

    async getOpenBasketsForParty(request: GetBasketsByParty): Promise<PartyBasketResponse> {
      if (request.party_id !== FakeOpenBasketOverviewAPI.EXPECTED_PARTY) {
        throw Error('Wrong party passed')

      }
      if (request.shop_id !== FakeOpenBasketOverviewAPI.EXPECTED_SHOP) {
        throw Error('Wrong shop passed')
      }
      return new PartyBasketResponse(FakeOpenBasketOverviewAPI.HARDCODED_PARTY_BASKETS(), 'basket-1')
    }

    async viewBasket(basketId: string): Promise<void> {
      FakeOpenBasketOverviewAPI.viewedBasket = basketId
    }
}


@registerDependency(REAL, OPEN_BASKET_OVERVIEW_API)
export class RealOpenBasketsOverviewAPI implements OpenBasketOverviewAPI {
  async viewBasket(basketId: string): Promise<void> {
    await executeOrderingRequest(new StartViewBasketForSalesCenterUser(basketId))
  }

  async getOpenBasketsForParty(request: GetBasketsByParty): Promise<PartyBasketResponse> {
    return await executeOrderingRequest(request)
  }
}
